import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Typography,
    Paper,
    CircularProgress,
    Box,
    TextField,
    Button,
    FormControl,
    Select,
    MenuItem,
} from "@mui/material";
import axios from "axios";
import "./userDetails.css";

const UserDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [userDetails, setUserDetails] = useState(null);
    const [loadingUser, setLoadingUser] = useState(true);
    const [error, setError] = useState(null);

    // States for scheduling an order
    const [category, setCategory] = useState("general scrap");
    const [pickupdate, setPickupDate] = useState("");
    const [pickuptime, setPickupTime] = useState("");
    const [address, setAddress] = useState("");
    const [material, setMaterial] = useState("");
    const [scrapImages, setScrapImages] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);

    useEffect(() => {
        const fetchUsersDetails = async () => {
            try {
                const token = JSON.parse(sessionStorage.getItem("accessToken"));
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/user/getuserinfo/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                const data = response.data.user;
                setUserDetails(data);
            } catch (err) {
                console.error(err);
                setError("Failed to fetch user details");
            } finally {
                setLoadingUser(false);
            }
        };

        fetchUsersDetails();
    }, [id]);

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);

        const previews = files.map((file) => {
            const reader = new FileReader();
            return new Promise((resolve) => {
                reader.onload = () => {
                    const base64 = reader.result.split(",")[1];
                    resolve({ base64, preview: reader.result });
                };
                reader.readAsDataURL(file);
            });
        });

        Promise.all(previews).then((images) => {
            setPreviewImages((prev) => [...prev, ...images.map((img) => img.preview)]);
            setScrapImages((prev) => [...prev, ...images.map((img) => img.base64)]);
        });
    };

    const handleScheduleOrder = async () => {
        const token = JSON.parse(sessionStorage.getItem("accessToken"));

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/user/scrap/${id}`,
                {
                    pickupdate,
                    pickuptime,
                    address,
                    category,
                    material,
                    scrapImages,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data.success) {
                alert("Order scheduled successfully!");
            }
        } catch (error) {
            console.error("Error scheduling order", error);
            alert("Failed to schedule order");
        }
    };

    if (loadingUser) {
        return (
            <Box className="loadingContainer">
                <CircularProgress />
            </Box>
        );
    }

    if (!userDetails) return <Typography>No details found</Typography>;

    return (
        <Box className="container">
            <Box className="gridContainer">
                <Box className="leftSection">
                    <Paper className="paper" elevation={3}>
                        <Typography variant="h5" className="centerTitle">
                            User Details
                        </Typography>
                        <Typography className="detailText">
                            <strong>User ID:</strong> {userDetails._id}
                        </Typography>
                        <Typography className="detailText">
                            <strong>Customer Name:</strong> {userDetails.username}
                        </Typography>
                        <Typography className="detailText">
                            <strong>Phone Number:</strong> {userDetails.phone}
                        </Typography>
                        <Typography className="detailText">
                            <strong>Wallet Balance:</strong> {userDetails.wallet.balance}
                        </Typography>
                    </Paper>
                </Box>

                <Box className="rightSection">
                    <Paper className="paper" elevation={3}>
                        <Typography variant="h5" className="centerTitle">
                            Schedule Order
                        </Typography>
                        <FormControl fullWidth margin="normal">
                            <Typography variant="body1">Category</Typography>
                            <Select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                <MenuItem value="general scrap">General Scrap</MenuItem>
                                <MenuItem value="vehicle scrap">Vehicle Scrap</MenuItem>
                                <MenuItem value="old cloth">Old Cloth</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Pickup Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={pickupdate}
                            onChange={(e) => setPickupDate(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Pickup Time"
                            type="time"
                            InputLabelProps={{ shrink: true }}
                            value={pickuptime}
                            onChange={(e) => setPickupTime(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Address"
                            multiline
                            rows={2}
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            label="Material Details"
                            multiline
                            rows={2}
                            value={material}
                            onChange={(e) => setMaterial(e.target.value)}
                        />
                        <Button variant="contained" component="label" style={{ marginTop: "10px" }}>
                            Upload Images
                            <input type="file" multiple hidden onChange={handleImageUpload} />
                        </Button>
                        <Box className="previewContainer" style={{ marginTop: "10px" }}>
                            {previewImages.map((image, index) => (
                                <img
                                    key={index}
                                    src={image}
                                    alt={`Preview ${index + 1}`}
                                    style={{ width: "100px", height: "100px", marginRight: "10px" }}
                                />
                            ))}
                        </Box>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ marginTop: "20px" }}
                            onClick={handleScheduleOrder}
                        >
                            Schedule Order
                        </Button>
                        <Button
                            variant="outlined"
                            style={{ marginTop: "20px", marginLeft: "20px" }}
                            onClick={() => navigate(`/admin/wallet/${id}`)}
                        >
                            Go to Wallet
                        </Button>
                    </Paper>
                </Box>
            </Box>
        </Box>
    );
};

export default UserDetails;